import { render, staticRenderFns } from "./JourneyUnit.vue?vue&type=template&id=0de61c36&scoped=true"
import script from "./JourneyUnit.vue?vue&type=script&lang=js"
export * from "./JourneyUnit.vue?vue&type=script&lang=js"
import style0 from "./JourneyUnit.vue?vue&type=style&index=0&id=0de61c36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de61c36",
  null
  
)

export default component.exports